import './.generated/_deps_ping';
import 'moment/locale/ja';
import './index.css';

import coreReducers from '01_core/reducers/coreReducers';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { combineReducers, createStore } from 'redux';

import App from './app/App';
import commonReducers from './common/commonReducers';
import * as serviceWorker from './serviceWorker';
import envUtil, { ENV_KEY } from '01_core/logics/envUtil';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

const reducers = combineReducers(Object.assign({}, coreReducers, commonReducers));

const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const handleReplaceReducer = (nextReducer) => {
  store.replaceReducer(nextReducer);
};

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

const consoleError = console.error.bind(console);
console.error = (message, ...args) => {
  if (typeof message === 'string' && message.startsWith('[React Intl]')) {
    return;
  }
  consoleError(message, ...args);
};

// MSALのインスタンスを作成
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: envUtil.getEnv(ENV_KEY.AZURE_CLIENT_ID),
    authority: `https://login.microsoftonline.com/${envUtil.getEnv(ENV_KEY.AZURE_TENANT_ID)}`,
  },
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <App replaceReducer={handleReplaceReducer} />
    </MsalProvider>
  </Provider>
);

serviceWorker.unregister();